export default "__VITE_ASSET__BYKv6xSR__"